module.exports = __webpack_public_path__ + "static/img/tongdun-logo.fd00209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tongdun-logo.png
// module id = /mdN
// module chunks = 0